import { getUser, getToken } from './service/AuthService';
import { getUserGoal } from './service/GoalService';

import Timer from './Timer';
import ProblematicLogEntry from './ProblematicLogEntry';
import TextExpander from './TextExpander';


import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import closeBttn from './assets/closeBttnSquare.svg';
import nextBttn from './assets/nextBttn.svg';



const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';

function convertTimestampToDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    const dateString = date.toLocaleDateString('en-US', options)
    //console.log(dateString)
    return dateString;
}

function convertTimestampToFullDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit', // "02"
        minute: '2-digit', // "30"
        second: '2-digit', // "15"
        timeZoneName: 'short' // "GMT+1"
    };
    const dateString = date.toLocaleDateString('en-US', options)
    //console.log(dateString)
    return dateString;
}

const Progress = () => {
    // //console.log('getting user goal');
    // //console.log(getUserGoal());

    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [timerHTML, setTimerHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastRelapseDate, setLastRelapseDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const user = getUser();
    //console.log(user)
    const token = getToken();
    const goal = getUserGoal();
    const today = new Date()
    const navigate = useNavigate();
    let logHidden = true;

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [learningContent, setLearningContent] = useState('');


    const relapseHandler = (event) => {
        event.preventDefault();
        navigate('/relapse');

    }

    // const expandLog = () => {
    //     //console.log('clicked yo')
    //     if(logHidden){
    //         document.querySelector('#pastProblematicLog').classList.remove('display-none')
    //         document.querySelector('#logBttn').innerText = "Hide Past Problematc Use"
    //         logHidden = false
    //     }
    //     else{
    //         document.querySelector('#pastProblematicLog').classList.add('display-none')
    //         document.querySelector('#logBttn').innerText = "Show Past Problematc Use"
    //         logHidden = true
    //     }
    // }

    async function fetchRelapseLog(){
         // do stuff here...
        //console.log('fetching the relapse log :)')
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        //console.log('here ; wath')

        const moduleParams = {
            mode: 'default'
        };

        //console.log('pre request object <3: ')
        const requestBody = {
            username: user.username,
            token: token,
            module: moduleParams,
        }

        //console.log('request object: ', requestBody)
        
        axios.post(logFetchUrl, requestBody, requestConfig).then(response => {
            //console.log('relapse log response object: ', response)
            //TODO: through here fetch the daily goal and the big long term goal as well
            // //console.log('returned body')
            // //console.log(`Status: ${response.status}`);
            // //console.log('Body: ', response.data);
            // //console.log('response')
            // //console.log(response.data.dynamoContent[response.data.dynamoContent.length-1])
            //console.log('end date: ', convertTimestampToFullDateString(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseEnd)))
            try {
                setLastImpact(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImpactDescriptionValue)
                setLastLesson(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImprovementText)
                let lastTitleStart = 'Started on '
                let lastTitleEntryDate = convertTimestampToDateString(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseStart))
                let lastTitleTemp = lastTitleStart + lastTitleEntryDate
                setLastTitle(lastTitleTemp)
                setLastRelapseDate(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseEnd))
                setLastDescription(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseDescription)  
                // //console.log('last submit date yooo: ', new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))          
                if(response.data.dynamoContent.length>=1){
                    setLastSubmitDate(new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))
                }
                for (let index = response.data.dynamoContent.length - 1; index >= 0; index--) {
                    const entry = response.data.dynamoContent[index];
                    // //console.log('description: ', entry.relapseDescription)
                    entries.push(<ProblematicLogEntry lastSubmitDate = {new Date(Number(entry.sk)).toString()} lastImpact= {entry.relapseImpactDescriptionValue} lastLesson= {entry.relapseImprovementText} lastDescription= {entry.relapseDescription} lastTitle= {convertTimestampToDateString(Number(entry.problematicUseStart))} />)
                    entries.push(<hr></hr>)
                }
                setEntryHTML(entries)
                setTimerHTML(<div className="item"><Timer lastRelapseDate={lastRelapseDate}/></div>)
            } catch (error) {
                console.log('possibly no entry data yet')
                setEntryHTML(<h3>No Data Yet. As You Use Your Relapse Journal. Your Entries Will Show Here.</h3>)
                setLastTitle(<h4>No Data. Start Using Your Relapse Journal.</h4>)
            }
            // //console.log(entries)
        }).catch(error => {
            //TODO: fix error of receiving null error
            //console.log('returned error')
            console.error('fetch error: ', error);
            setErrorMessage('Sorry the server is down. Please try again later.');
            if(error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else if(error.response.status === 401 ){
                ////console.log('need to login again')
                navigate('/login')
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }
    let questionsLearning = [
        {
            question: 'Set Back Log',
            assets: entryHTML,
        },
    ];

    const handleCloseLearningPopup = () => {
        //console.log('trying to close homes')
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };
    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };

    const handleSubmitLearningClosePopup = () => {
        // //console.log('lesss navigate to the home screen homes')
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed

    };

    const handleOpenLearningPopup = () => {
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    };

    const renderFormLearning = () => {
        try{
            const currentQ = questionsLearning[currentQuestion];
            const { question, options } = currentQ;
            return (
                <div className="formContainer">
                    <div className="button-group" style={{ float: 'right' }}>
                        <button onClick={handleCloseLearningPopup} style={{border:'none'}}> 
                            <img className="closeBttn" src={closeBttn} alt="CloseModalBttn" />
                        </button>
                    </div>
                    <h2 style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '1rem' }}>{question}</h2>
                    <div className="learningTextContent" style={{overflowY: "auto", height: "80%", minHeight:"470px", textAlign: "center"}}> {currentQ.assets} </div>
                    <div className="popupButtonGroup">
                    {currentQuestion > 0 && currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {/* {currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} >Next</button>
                    ) : (
                        <button id="learningSubmit" className="popupNavigationBttn" onClick={handleSubmitLearning} >Submit</button>
                    )} */}
                    {currentQuestion >= 0 && currentQuestion < questionsLearning.length - 3 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsLearning.length - 3 ? (
                        <button id="relapseSubmit" className="popupNavigationBttn" style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    </div>
                </div>
            );
        
        }
        catch{
            //console.log('some error yo -- need to fix this')
        }
        
    };

    useEffect(() => {    
        fetchRelapseLog()

    }, []) 
    return (
        <div className="wrapper" style={{ marginTop: '6.5rem', marginLeft: '1rem', marginRight: '1rem'}}>
            <div className="dailyPopup">
                {/* <button onClick={handleOpenPopup}>hello</button> */}
                {/* #4490C3 */}
                <div className="popupContainer" id="learning-popup"  style={{ display: 'none' }} >{renderFormLearning()}</div>
                {/* <div className="popupContainer"  id="regulation-popup"  style={{ display: 'none' }}>{renderFormRegulation()}</div> */}
            </div>
            <div className='donut-parent'>
                <div className="donut"></div>
            </div>
            <div>
                <div>
                    {/* <div className="container"> <button onClick = { relapseHandler }> Log Problematic Use </button> </div> */}
                    {/* <h3 className="container"> Digital Wellness is a journey -- Not a destination</h3> */}
                    <div>
                        <h2 className="text-center"> Digital Wellness <br/> Progress Overview</h2>
                    </div>
                    {/* <h4 className="text-center" style={{ marginTop:'0.5rem' }}> <span className="highlight">latest insight:</span> You're always practicing something. Choose growth, curiosity, and love.</h4> */}

                    {/* <p className="text-center"> The why: I will { user.currentGoal }</p> */}
                    {/* <p className="text-center"> Today's goal: { goal.textcontent } </p> */}
                    
                </div>
                <div>
                    <div>
                        {/* <h4 className="text-center"> Last Set Back: { lastTitle } </h4> */}
                        {/* <h4 className="text-center" style={{ marginTop:'3rem' }}> <span className="highlight">{name}'s big goal:</span> <TextExpander text={currentGoal} /></h4> */}

                        <h4 className="text-center" style={{ marginTop:'3rem' }}> <span className="highlight">Latest Insight:</span> <TextExpander text={lastLesson} /></h4>
                        <h6 className="text-center" style={{ marginTop:'0.5rem', marginBottom:'0.5rem' }}> <span > Current Streak: { lastTitle } </span> </h6>
                        <div className="timer-container">
                        {/* <div className="item">
                            <h3> Days from last Relapse </h3>
                            <h1> { Math.ceil((today - lastSubmitDate) / 8.64e7) } </h1>
                        </div> */}
                        {/* <div className="item">
                            <h4> Productive hours towards goal </h4>
                            <h2> 5 </h2>
                        </div> */}
                        <div className="item">
                            <Timer lastRelapseDate={lastRelapseDate}/>
                        </div>
                        {/* {timerHTML} */}
                    </div>
                        {/* <p className="text-center"> { lastDescription } </p>
                        <div className="container">
                            <div className="item">
                                Key Lessons
                                <div className='left-text'>
                                    <p> { lastLesson } </p>
                                </div>
                            </div>
                            <div className="item">
                                Impact
                                <div>
                                    <p> { lastImpact } </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div> 
                        {/* <button onClick= { expandLog } id="logBttn"> Show Set Back Log </button>  */}
                        <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                            {/* <button className="homeBttn" onClick={expandLog}  >Show Set Back Log</button> */}
                            <button className="homeBttn" onClick={handleOpenLearningPopup} >Show Set Back Log</button>
                            {/* <button className="homeBttn" style={{ marginTop:'1rem'}} > Show Workout Log </button> */}


                            {/* <button className="homeBttn" style={{ marginTop:'1rem'}} onClick={handleOpenRelapsePopup}>Set Back Support </button>
                            <button className="homeBttn" style={{ marginTop:'1rem' }} onClick={() => {window.open("https://trampolinehealth.circle.so/home", "_blank");}}>Trampoline Community</button> */}
                        </div>
                        <br></br>
                        <br></br>
                        {/* <div className="display-none" id="pastProblematicLog">
                            { entryHTML }
                        </div> */}
                    </div>
                </div>
            </div>
            {errorMessage && <p className="message"> { errorMessage } </p>}
        </div>
    )
}

export default Progress;